import { APICore } from "helpers/api/apiCore";

import config from "../../config";
import { CreateCustomerBeneficiaryType } from "./types";

const api = new APICore();

function fetchCustomerBeneficiaryApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.customerId}`;
  return api.get(`${baseUrl}`, params);
}

function createCustomerBeneficiaryApi(params: any) {
  let backendApiUrl = "";

  let apiData: any = {
    accountnum: params.accountnum.trim(),
    corporateCode: params.corporateCode.trim(),
    ifsccode: params.ifsccode.trim(),
    name: params.name.trim()
  };

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.customerId}`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.customerId}?draft=${params.draft}`;
  }
  const baseUrl = backendApiUrl;
  return api.create(`${baseUrl}`, apiData);
}

function fetchCustomerBeneficialApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}`;
  return api.get(`${baseUrl}`, {});
}

function fetchCustomerBeneficialVersionDetailsApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.externalID}/${params.customerId}/versions/${params?.internalID}`;
  return api.get(`${baseUrl}`, {});
}

function fetchCustomerBeneficialLatestVersionApi(params: any) {
  const query = {
    modifyLatest: params?.status === "New" ? false : true
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.customerId}/${params.id}/latestVersion`;
  return api.get(`${baseUrl}`, query);
}

function updateCustomerBeneficialApi(params: any) {
  // console.log("params", params);

  let backendApiUrl = "";

  let apiData: any = {
    accountnum: params.accountnum.trim(),
    corporateCode: params.corporateCode.trim(),
    default: params.default,
    ifsccode: params.ifsccode.trim(),
    name: params.name.trim()
  };

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.externalUserId}/${params.customerId}`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.externalUserId}/${params.customerId}?draft=${params.draft}`;
  }
  const baseUrl = backendApiUrl;
  return api.update(`${baseUrl}`, apiData);
  //   const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.externalUserId}/${params.externalUserId}/${params.customerId}`;
  //   return api.update(`${baseUrl}`, param);
}

function fetchCustomerBeneficialVersionApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}/versions`;
  return api.get(`${baseUrl}`, params);
}


function deleteCustomerBeneficialApi(params: any) {
 
  let externalId = params.externalCustomerId;
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}`;
  return api.delete(`${baseUrl}`);
}

function approveCustomerBeneficialApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalId = params.externalCustomerId;
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function rejectCustomerBeneficialApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalId = params.externalCustomerId;
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function sentBackCustomerBeneficialApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}/sent-back`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function blockCustomerBeneficialApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.customerId}/${params.id}/block`;
  return api.updatePatch(`${baseUrl}`, param);
}

function freezeCustomerBeneficialApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}/freeze`;
  return api.updatePatch(`${baseUrl}`, param);
}
function unFreezeCustomerBeneficialApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/beneficiaries/customer-relations/${params.id}/${params.customerId}/unfreeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

export {
  fetchCustomerBeneficiaryApi,
  createCustomerBeneficiaryApi,
  fetchCustomerBeneficialApi,
  updateCustomerBeneficialApi,
  fetchCustomerBeneficialVersionApi,
  approveCustomerBeneficialApi,
  rejectCustomerBeneficialApi,
  sentBackCustomerBeneficialApi,
  blockCustomerBeneficialApi,
  freezeCustomerBeneficialApi,
  unFreezeCustomerBeneficialApi,
  fetchCustomerBeneficialVersionDetailsApi,
  fetchCustomerBeneficialLatestVersionApi,
  deleteCustomerBeneficialApi
};
